import { includes, isEqual, partial } from 'lodash';
import { z } from 'zod';

function parseEnv() {
  const envSchema = z.object({
    APP_ENV: z.string(),
    APP_VERSION: z.string(),
    BUGSNAG_API_KEY: z.string(),
    CLOUDFLARE_TRACE_URL: z.string().optional(),
    FIREFLY_API_URL: z.string(),
    FIREFLY_API_V3_URL: z.string(),
    FIREFLY_APPLY_URL: z.string().default('https://my.talquinelectric.com/apply'),
    FIREFLY_APPLY_API_URL: z.string(),
    DEBUG_TANSTACK_ROUTER: z.string()
      .refine(partial(includes, ['true', 'false']))
      .transform(partial(isEqual, 'true'))
      .optional(),
    DEBUG_TANSTACK_QUERY: z.string()
      .refine(partial(includes, ['true', 'false']))
      .transform(partial(isEqual, 'true'))
      .optional()
  });

  const envVars = Object.entries(import.meta.env)
    .reduce<Record<string, string>>((final, current) => {
      const [key, value] = current;

      if (key.startsWith('VITE_')) {
        final[key.replace('VITE_', '')] = value;
      }

      return final;
    }, {});

  const parsedEnv = envSchema.safeParse(envVars);

  if (!parsedEnv.success) {
    throw new Error(
      `Invalid env provided:
      The following keys are missing or invalid:
      ${Object.entries(z.treeifyError(parsedEnv.error).properties ?? {}).map(([key, value]) => `${key}: ${value.errors.join(', ')}`).join('\n')}
      `
    );
  }

  return parsedEnv.data;
}

let envCache: ReturnType<typeof parseEnv>;

export function getEnv() {
  if (!envCache) {
    envCache = parseEnv();
  }

  return envCache;
}
